import Link from "next/link";
import React, { useContext } from "react";
import Remote from "../LoaderRemote";
import Image from "next/image";
import BreadCrumb from "../BreadCrumb";
import styles from "../VillaItem.module.css";
import { StoreContext } from "../../context/context";

const CategoryList = ({ ssr, action }) => {
  const { page } = useContext(StoreContext);
  return (
    <div>
      {ssr.result.BreadCrumb && (
        <BreadCrumb data={ssr.result.BreadCrumb}></BreadCrumb>
      )}
      <div className="container pb-6">
        <div className="grid grid-cols-2 gap-2 lg:gap-5 lg:grid-cols-4">
          {page._category &&
            page._category.map((item, key) => (
              <div
                key={key}
                className="relative shadow-inner flex items-end justify-start w-full text-left h-32 lg:h-96 rounded-lg overflow-hidden"
              >
                <Link href={item.url}>
                  <a
                    title={item.title}
                    className="font-medium text-md group pb-2"
                  >
                    {item.resim && (
                      <Image
                        layout="fill"
                        src={item.resim}
                        objectFit={"cover"}
                        sizes="(max-width: 768px) 60vw,
                  25vw"
                        loader={Remote}
                        alt={item.title}
                      ></Image>
                    )}
                    <h2
                      className={
                        "z-10 px-2 lg:px-5 relative text-white font-bold text-sm mm:text-base lg:text-2xl transition-all duration-200 translate-y-0 group-hover:translate-y-0 " +
                        (action != "Destination" ? "lg:mb-4 " : "") +
                        styles.Ribbon
                      }
                    >
                      {item.baslik}
                    </h2>
                    {action == "Destination" && 1 === 2 && (
                      <span className="z-10 px-2 lg:px-5 inline-block lg:h-0 group-hover:h-auto relative text-white lg:translate-y-full duration-200 transition-all transform lg:opacity-0 group-hover:opacity-100 group-hover:translate-y-0">
                        {item.total} Villa
                      </span>
                    )}
                  </a>
                </Link>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryList;
